import moment from 'moment';

import {
    formatThaiDateUi,
    getCreateDateTime
} from '../../utils/DateUtils';

export const wtDocMasterModel = () => {
    return {
        wtDocId: null,
        wtDocNo: null,
        wtDocType: null,
        wtDocEmpId: null,
        wtDocEmpCode: null,
        wtDocEmpName: null,
        wtDocDate: formatThaiDateUi(moment()),
        wtDocTransDate: formatThaiDateUi(moment()),
        wtDocCreatedDate: getCreateDateTime(),
        wtDocCreatedBy: window.localStorage.getItem('name'),
        wtDocStatus: null,
        wtDocSeq: null,
        wtDocRemark: null,
        wtDocCompId: window.localStorage.getItem('company'),
        wtDocShowFront: null,
        refDocId: null,
        refDoc: null,
        refDocDate: null,
        fWtId: null,
        fZoneId: null,
        fLtId: null,
        tWtId: null,
        tZoneId: null,
        tLtId: null,

        // ใช้สำหรับแสดงเฉยๆ
        arAdd1: null,
        arAdd2: null,
        arAdd3: null,
        arProvince: null,
        arZipcode: null,
        arTaxNo: null,
    };
};